// @file Enums

enum EditorVariant {
  PHONE = 'phone',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  DESKTOP_DOCKED = 'desktop_docked',
}

enum AttachmentPickerState {
  IDLE = 'idle',
  LOADING = 'loading',
  DRAGGING = 'dragging',
}

// Must match app/javascript/vuexstore/modules/content_picker.ts#ContentPickerSource
enum ContentPickerSource {
  FileBrowser = 'file',
  LinkInput = 'link',
  WebBrowser = 'web_search',
  PhotoBooth = 'photo_booth',
  VideoRecorder = 'video_recorder',
  AudioRecorder = 'audio_recorder',
  DrawingCanvas = 'drawing',
  PadletBrowser = 'padlet',
  MapBrowser = 'location_search',
  ScreenshareRecorder = 'screen_recorder',
  AiImageSearch = 'ai_image_search',
  ImageSearch = 'image_search',
  VideoSearch = 'video_search',
  AudioSearch = 'audio_search',
  GifSearch = 'gif_search',
  Poll = 'poll',
  GoogleDrive = 'google_drive',
  AiTalk = 'ai_talk',
  MediaLibrary = 'media_library',
}

export { AttachmentPickerState, ContentPickerSource, EditorVariant }
